<template>
  <div class="wrapper">
    <el-dialog
      title="订单备注"
      :visible.sync="showAddOrEdit"
      width="1200px"
      :before-close="cancelFun"
      class="remark-dialog"
    >
      <div class="dialog-content">
        <!-- 搜索区域 -->
        <el-card class="search-card" shadow="never">
          <div class="card-header-title">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
          </div>
          <el-form ref="form" inline :model="searchData" label-width="90px">
            <el-form-item label="订单号">
              <el-input 
                v-model="searchData.orderNo" 
                size="small" 
                placeholder="请输入订单号" 
                prefix-icon="el-icon-document"
                clearable
                style="width: 250px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注时间">
              <el-date-picker
                style="width: 280px;"
                size="small"
                v-model="searchData.timeSlot"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                prefix-icon="el-icon-date"
                unlink-panels
                clearable
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label=" ">
              <el-button 
                type="primary" 
                size="small" 
                icon="el-icon-search" 
                @click="getList()"
                class="search-btn"
              >搜索</el-button>
              <el-button 
                type="info" 
                size="small" 
                icon="el-icon-refresh" 
                @click="reset"
                class="reset-btn"
              >重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格区域 -->
        <el-card class="table-card" shadow="never">
          <div class="card-header-title">
            <div class="title-left">
              <i class="el-icon-s-grid"></i>
              <span>备注列表</span>
            </div>
            <div class="title-right">
              <div class="header-stats">
                <div class="stat-item">
                  <span class="stat-label">总记录数</span>
                  <span class="stat-value">{{ total }}</span>
                </div>
              </div>
              <el-button
                type="primary"
                icon="el-icon-download"
                size="small"
                @click="downloadExcel"
                class="export-btn"
              >导出</el-button>
            </div>
          </div>
          <tp-table
            :isNeedSerialNumber="false"
            :tableData="list"
            :columns="columns"
            :totalNum="total"
            :current-page.sync="currentPage"
            :pageSize.sync="pageSize"
          />
        </el-card>
      </div>

      <!-- 添加备注对话框 -->
      <el-dialog title="添加备注" :visible.sync="dialogVisible" width="700px" class="add-remark-dialog">
        <el-form ref="formData" :model="formData" label-width="80px">
          <el-form-item label="备注">
            <el-input
              style="width: 100%;"
              type="textarea"
              rows="4"
              v-model="formData.content"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="info" @click="dialogVisible = false" size="small" class="cancel-btn">取 消</el-button>
            <el-button type="primary" @click="saveRemark" size="small" class="save-btn">保 存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun" class="close-btn">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getRemarkListAPI, handleAddRemarkAPI, DownloadAPI } from "./api";

const columns = [
  {
    label: "客户姓名",
    prop: "member",
    minWidth: "100",
    customRender(h, row) {
      return <p class="table-cell-text member-name">{row["member"]?.["memberName"] || '-'}</p>;
    },
  },
  {
    label: "手机号",
    prop: "member",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["member"]?.["mobile"] || '-'}</p>;
    },
  },
  {
    label: "订单号",
    prop: "orderNo",
    minWidth: "220",
    customRender(h, row) {
      return <p class="table-cell-text">{row["orderNo"] || '-'}</p>;
    },
  },
  {
    label: "跟进人",
    prop: "traceUser",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["traceUser"]?.["userName"] || '-'}</p>;
    },
  },
  {
    label: "备注时间",
    prop: "createTime",
    minWidth: "180",
    customRender(h, row) {
      return <p class="table-cell-text">{row["createTime"] || '-'}</p>;
    },
  },
  {
    label: "备注",
    prop: "content",
    minWidth: "200",
    customRender(h, row) {
      return <p class="table-cell-text">{row["content"] || '-'}</p>;
    },
  },
];

export default {
  name: "MemberOrderRemarkList",
  mixins: [authBtnMixin],
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        orderNo: "",
        timeSlot: [],
      },
      formData: {
        content: "",
        orderNo: "",
      },
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  provide() {
    return {
      context: this,
    };
  },
  mounted() {
    this.getList();
  },
  activated() {
    this.getList();
  },
  methods: {
    async getList() {
      const { orderNo, timeSlot } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize };
      if (orderNo) params.orderNo = orderNo;
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0] || '';
        params.rightCreateDate = timeSlot[1] || '';
      }
      const res = await getRemarkListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    addRemark(orderNo) {
      this.dialogVisible = true;
      this.formData = {
        content: "",
        orderNo,
      };
    },
    saveRemark() {
      handleAddRemarkAPI(this.formData).then(() => {
        this.$message.success("添加成功");
        this.getList();
        this.dialogVisible = false;
      });
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    downloadExcel() {
      const { orderNo, timeSlot } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize };
      if (orderNo) params.orderNo = orderNo;
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0] || '';
        params.rightCreateDate = timeSlot[1] || '';
      }
      DownloadAPI(params);
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
::v-deep .remark-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 20px;
        font-weight: 700;
        color: #1a1e25;
        display: flex;
        align-items: center;
        gap: 10px;
        
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 20px;
          background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
          border-radius: 2px;
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
      background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      background: #fafbfc;
      border-top: 1px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 20px;
  min-height: 400px;
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  .title-left {
    display: flex;
    align-items: center;
    gap: 8px;
    
    i {
      font-size: 18px;
      color: #409EFF;
    }
  }
  
  .title-right {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .header-stats {
    display: flex;
    gap: 16px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 12px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 8px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 6px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
    z-index: 1;
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  ::v-deep .el-form {
    &.el-form--inline {
      .el-form-item {
        display: inline-flex;
        align-items: center;
        margin-right: 24px;
        margin-bottom: 16px;
      }
    }

    .el-form-item {
      .el-form-item__label {
        color: #303133;
        font-weight: 600;
        letter-spacing: 0.3px;
        font-size: 14px;
        position: relative;
        
        &::after {
          content: ':';
          margin-left: 2px;
          color: #909399;
        }
      }

      .el-input {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        .el-input__inner {
          border-radius: 10px;
          height: 38px;
          line-height: 38px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 13px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
        }

        &.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          background: #ffffff;
        }
      }

      .el-date-editor {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        .el-range-separator {
          padding: 0 10px;
          color: #606266;
          font-weight: 500;
        }

        .el-range-input {
          width: 35%;
          font-size: 13px;
        }

        .el-input__inner {
          border-radius: 10px;
          height: 38px;
          border: 1.5px solid #E4E7ED;
          background: #fafbfc;
        }
        
        &:hover .el-input__inner {
          border-color: #C0C4CC;
          background: #ffffff;
        }

        &.is-active,
        &:focus-within {
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          border-radius: 10px;
          
          .el-input__inner {
            background: #ffffff;
          }
        }
      }
    }

    .search-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }

    .reset-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
      border: none;
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;

      &:hover {
        background: linear-gradient(135deg, #909399 0%, #82848a 100%);
        box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
    z-index: 1;
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  .export-btn {
    border-radius: 10px;
    padding: 8px 20px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }

    .table-cell-text {
      margin: 0;
      color: #606266;
      font-size: 13px;
      line-height: 1.8;
      font-weight: 400;
    }

    .member-name {
      font-weight: 600;
      color: #303133;
      font-size: 14px;
    }

    .el-table__fixed-right {
      height: 100% !important;
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// 对话框底部按钮
.dialog-footer {
  .close-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    }
  }
}

// 添加备注对话框样式
::v-deep .add-remark-dialog {
  .el-dialog {
    border-radius: 12px;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
    }
    
    .el-form-item {
      .el-form-item__label {
        color: #303133;
        font-weight: 600;
      }
      
      .el-textarea {
        .el-textarea__inner {
          border-radius: 10px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
    
    .cancel-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
      border: none;
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover {
        background: linear-gradient(135deg, #909399 0%, #82848a 100%);
        transform: translateY(-2px);
      }
    }
    
    .save-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        transform: translateY(-2px);
      }
    }
  }
}
</style>
